// ========================================
// COMPONENTE FOOTER GLOBAL
// src/components/Footer.jsx
// ========================================

import React from 'react';
import { Instagram, MessageCircle, Phone, Mail, MapPin, ExternalLink } from 'lucide-react';

const Footer = () => {
  const anoAtual = new Date().getFullYear();
  
  const abrirWhatsApp = () => {
    const numero = '5546999740515';
    const mensagem = encodeURIComponent('Olá! Preciso de suporte para o sistema Primalia PVC.');
    window.open(`https://wa.me/${numero}?text=${mensagem}`, '_blank');
  };

  const abrirInstagram = (perfil) => {
    window.open(`https://www.instagram.com/${perfil}`, '_blank');
  };

  return (
    <footer className="bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 text-white mt-auto">
      {/* Linha decorativa superior animada */}
      <div 
        className="h-1"
        style={{ 
          background: 'linear-gradient(135deg, #0D5DFC 0%, #0099cc 25%, #0D5DFC 50%, #0099cc 75%, #0D5DFC 100%)',
          backgroundSize: '400% 400%',
          animation: 'gradientShift 8s ease infinite'
        }}
      ></div>
      
      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Grid principal - 2 colunas */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          
          {/* Coluna Esquerda - Inovacom */}
          <div className="text-center md:text-left pt-4">
            <div className="flex items-center justify-center md:justify-start gap-2 mb-3">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center shadow-lg">
                <span className="text-white font-bold text-lg">i</span>
              </div>
              <div>
                <h3 className="font-bold text-white">InovaFlow</h3>
                <p className="text-xs text-slate-400">Sistema de Gestão Empresarial</p>
              </div>
            </div>
            <p className="text-sm text-slate-400 mb-3">
              Desenvolvido por <span className="text-cyan-400 font-semibold">Inovacom Agência Digital</span>
            </p>
            <button
              onClick={() => abrirInstagram('inovacom_agencia')}
              className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-600 to-cyan-600 rounded-lg text-sm font-medium hover:from-blue-500 hover:to-cyan-500 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-blue-500/30"
            >
              <Instagram size={18} />
              @inovacom_agencia
            </button>
          </div>

          {/* Coluna Direita - Primalia */}
          <div className="text-center md:text-right">
            <div className="flex items-center justify-center md:justify-end mb-3 mt-2">
              <img 
                src="/logo-primalia.svg" 
                alt="Primalia PVC" 
                className="h-16 w-auto object-contain brightness-0 invert"
              />
            </div>
            <div className="space-y-1.5 text-sm text-slate-400">
              <p className="flex items-center justify-center md:justify-end gap-2">
                <MapPin size={14} className="text-cyan-400 flex-shrink-0" />
                <span>Rua Getúlio Dal Pasquale, 200 - São Francisco</span>
              </p>
              <p className="flex items-center justify-center md:justify-end gap-2 text-xs">
                <span className="text-slate-500">CEP: 85504-610 - Pato Branco - PR</span>
              </p>
              <p className="flex items-center justify-center md:justify-end gap-2">
                <Phone size={14} className="text-cyan-400 flex-shrink-0" />
                <span>(46) 3040-0290</span>
              </p>
              <p className="flex items-center justify-center md:justify-end gap-2">
                <Mail size={14} className="text-cyan-400 flex-shrink-0" />
                <a href="mailto:comercial@primaliapvc.com.br" className="hover:text-cyan-400 transition-colors">
                  comercial@primaliapvc.com.br
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Linha divisória */}
        <div className="w-full h-px bg-gradient-to-r from-transparent via-slate-600 to-transparent my-6"></div>

        {/* Rodapé inferior */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-slate-500">
          <p>
            © {anoAtual} <span className="text-slate-400">Primalia PVC</span>. Todos os direitos reservados.
          </p>
          <p className="flex items-center gap-2">
            Powered by 
            <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent font-semibold">
              Inovacom Agência Digital
            </span>
            <span className="text-slate-600">|</span>
            <span className="text-cyan-400 font-medium">InovaFlow v1.0</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
